<template>
    <el-card class="box-card full-screen recharge-apply">
      <div ref="pageHead" class="table-page-head">
        <el-form :inline="true" :model="queryForm">
          <el-form-item :label="$t('date')">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="~"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              value-format="yyyy-MM-dd"
              size="small"
              unlink-panels
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dealType')">
            <el-select
  v-model="queryForm.businessCode"
  :placeholder="$t('all')"
  filterable
  size="small"
>
  <el-option :label="$t('all')" value=""></el-option>
  <template v-for="item in businessList">
    <el-option-group
      v-if="item.parentId == 0"
      :key="'g' + item.id"
      :label="$t(item.name)"
    >
      <template v-for="t in businessList">
        <el-option
          v-if="t.parentId == item.id"
          :key="'o' + t.id"
          :label="$t(t.name)"
          :value="t.businessCode"
        ></el-option>
      </template>
    </el-option-group>
  </template>
</el-select>
        </el-form-item>
        <el-form-item :label="$t('transactionCode')">
          <el-input v-model="queryForm.transactionCode" size="small"></el-input>
        </el-form-item>
          <el-form-item :label="$t('agent')" v-if="isOrgChief">
  <el-select
    v-model="queryForm.createId"
    size="small"
    :placeholder="$t('all')"
    clearable
    filterable
    style="width: 220px"
  >
  <el-option
  v-for="a in agentList"
  :key="a.id"
  :label="(a.name || '') + ' ' + (a.surname || '') + ' — ' + a.loginName"
  :value="a.id"
/>
  </el-select>
</el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="getList"
              :loading="isLoading"
              ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
            >
            <el-button size="small" @click="onReset">{{ $t("reset") }}</el-button>
          </el-form-item>
        </el-form>
        <el-row>
          <div class="table-total-amount">
    {{ $t('totalAmount') }} :
    <span class="franc">FCFA</span>
    <strong>{{ totalAmount ? totalAmount.formatMoney(0) : 0 }}</strong>
  </div>
        </el-row>
      </div>
      <div
        class="data-table"
        :style="{
          top: queryTableHeight,
          height: `calc(100% - ${queryTableHeight} - 70px)`,
        }"
      >


            <el-table
              :data="transactionRecord"
              style="width:100%"
              size="mini"
              height="100%"
            >
            <el-table-column :label="$t('agent')" min-width="160" v-if="isOrgChief">
  <template slot-scope="scope">
    {{ scope.row.createName }} {{ scope.row.createSurname }}
    <div class="text-muted" style="font-size: 12px">
      {{ scope.row.createUserLoginName }}
    </div>
  </template>
</el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('tradingTime')"
                width="160"
              >
                <template slot-scope="scope">
                  {{ $manba(scope.row.createTime).format("ymdhms") }}
                </template>
              </el-table-column>
              <el-table-column
                prop="businessName"
                :label="$t('dealType')"
                min-width="160"
              >
                <template slot-scope="scope">
                  {{ $t(scope.row.businessName) }}
                </template>
              </el-table-column>
              <el-table-column prop="amount" :label="$t('transactionAmount')" min-width="160">
  <template slot-scope="scope">
    <span class="franc">FCFA</span>
    {{ scope.row.amount ? Math.abs(scope.row.amount).formatMoney(0) : 0 }}
  </template>
</el-table-column>
              <el-table-column prop="status" :label="$t('status')" width="160">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0" class="text-info">{{
                    $t("await")
                  }}</span>
                  <span v-if="scope.row.status == 1" class="text-primary">{{
                    $t("trading")
                  }}</span>
                  <span v-if="scope.row.status == 2" class="text-success">{{
                    $t("completeTransaction")
                  }}</span>
                  <span v-if="scope.row.status == 3" class="text-danger">{{
                    $t("failureTransaction")
                  }}</span>
                  <span v-if="scope.row.status == 4" class="text-warning">{{
                    $t("reversaling")
                  }}</span>
                  <span v-if="scope.row.status == 5" class="text-danger">{{
                    $t("completeReversal")
                  }}</span>
                  <span v-if="scope.row.status == 6" class="text-danger">{{
                    $t("failureReversal")
                  }}</span>
                </template>
              </el-table-column>
              <!--<el-table-column prop="regionName" :label="$t('region')" min-width="120"></el-table-column>-->
              <el-table-column
                prop="region"
                :label="$t('region')"
                min-width="160"
              >
                <template slot-scope="scope">{{
                  formatRegion(scope.row.region)
                }}</template>
              </el-table-column>
              <el-table-column
                prop="orgName"
                :label="$t('org')"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="transactionCode"
                :label="$t('Transaction no.')"
                min-width="200"
              >
              </el-table-column>
              <el-table-column
                prop="createRemark||remark"
                :label="$t('explain')"
                min-width="200"
              >
                <template slot-scope="scope">
                  <div class="overstep-hidden">
                    <translation
                      v-if="scope.row.createRemark"
                      :text="scope.row.createRemark"
                    />
                    <translation
                      v-if="scope.row.remark"
                      :text="scope.row.remark"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
      </div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 30, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total || 0"
        @prev-click="setCurrentChange"
        @next-click="setCurrentChange"
      />
    </el-card>
  </template>
  
  <script>
  import translation from "../../components/specialTranslation.vue";
  import transactionInfo from "@/api/transactionInfo";
  import country from "@/api/country";
import org from "@/api/org.js";
import business from "@/api/business";
  
  export default {
    // name: "home",
    components: { translation },
    data() {
  return {
    queryForm: {
      date: null,
      businessCode: "",
      transactionCode: "",
      createId: null,
      status: null,
    },
    totalAmount: 0,
    agentList: [],
    transactionRecord: [],
    businessList: [],
    isLoading: false,
    queryTableHeight: String,
    pageSize: 20,
    currentPage: 1,
    tableData: {},
  };
},
    computed: {
      countryList() {
        return this.$store.state.globalParameter.countryList;
      },
      loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    isOrgChief() {
  const job = this.loginInfo.job;
  return job === "CHEF D'AGENCE" || job === "DISTRIBUTEUR";
},
    },
    watch: {},
    methods: {
        getAgentList() {
  org.getMyOrgUserList({
    param: { current: 1, size: 200 },
    success: (res) => {
      if (res.code === 200 && res.data) {
        this.agentList = res.data.records || [];
      }
    },
  });
},
      
getBusiness() {
  business.getList({
    success: (res) => {
      this.businessList = Array.isArray(res.data)
        ? res.data.filter(Boolean).reverse()
        : [];
      this.getList();
    },
    failing: () => {
      this.getList();
    },
  });
},

        formatRegion(region) {
  if (!region || !this.countryList.length) return "";
  const p1 = this.countryList.find((c) => c.id == region);
  if (!p1) return "";
  const p2 = this.countryList.find((c) => c.id == p1.parentId);
  return p2 ? p2.name + " / " + p1.name : p1.name;
},
      getCountry() {
        let _this = this;
        country.getList({
          success: (res) => {
            _this.$set(_this, "countryList", res.data);
          },
        });
      },
      getList() {
  this.isLoading = true;

  const params = {
    current: this.currentPage,
    size: this.pageSize,
  };
  if (this.queryForm.date && this.queryForm.date.length === 2) {
    params.startTime = this.$manba(this.queryForm.date[0]).format("ymd");
    params.endTime   = this.$manba(this.queryForm.date[1]).format("ymd");
  }
  if (this.queryForm.businessCode)
    params.businessCode = this.queryForm.businessCode;
  if (this.queryForm.transactionCode)
    params.transactionCode = this.queryForm.transactionCode.trim(); 
  if (this.queryForm.status !== null && this.queryForm.status !== "")
    params.status = this.queryForm.status;
  if (this.queryForm.createId)
    params.createId = this.queryForm.createId;

  transactionInfo.getAgentPage({
    param: params,
    success: (res) => {
      this.isLoading = false;
      this.tableData = res.data || {};
      this.transactionRecord = (res.data && res.data.records) || [];
      this.totalAmount = (res.data && res.data.totalAmount) || 0;
    },
    failing: () => {
      this.isLoading = false;
    },
  });
},
onReset() {
  this.queryForm = {
    date: null,
    businessCode: "",
    transactionCode: "",
    status: null,
    createId: null,
  };
  this.currentPage = 1;
  this.getList();
},

handleSizeChange(val) { this.pageSize = val; this.getList(); },
handleCurrentChange(val) { this.currentPage = val; this.getList(); },
setCurrentChange(val) { this.currentPage = val; this.getList(); },
  
    },
    mounted() {
  let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
  this.queryTableHeight = queryTableHeight + "px";
  if (!this.countryList || this.countryList.length === 0)
    this.$store.dispatch("globalParameter/getCountry");
  if (this.isOrgChief) this.getAgentList();
  this.getBusiness();
},
  };
  </script>
  <style lang="less">
  .table-total-amount {
  padding: 8px 0;
  font-size: 14px;
  strong {
    color: #f56c6c;
    font-size: 16px;
  }
}
  .home {
    i {
      font-size: 14px;
    }
    .residual-space {
      margin-top: 15px;
      position: absolute;
      top: 155px;
      bottom: 0;
      left: 0;
      right: 0;
      .el-col {
        height: 100%;
      }
      .el-card {
        height: 100%;
      }
    }
    .custom-dialog {
      color: red;
      .el-dialog__body {
        padding: 0 20px;
        p {
          letter-spacing: 1.5px;
          line-height: 24px;
        }
      }
    }
    
  }
  </style>
  